import { Actions } from './wards.actions'
import { fromJS } from 'immutable'
import * as WardsTypes from './wards.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 10,
    },
    total: 0,
    results: 0,
  },
  createWard: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  updateWard: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function wardsReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case WardsTypes.UPDATE_WARD_REQUEST: {
      return state.setIn(['updateWard', 'isLoading'], true)
    }

    case WardsTypes.UPDATE_WARD_SUCCESS: {
      return state.setIn(['updateWard', 'isLoading'], false)
    }

    case WardsTypes.UPDATE_WARD_FAILURE: {
      return state.setIn(['updateWard', 'isLoading'], false)
    }

    case WardsTypes.CREATE_WARD_REQUEST: {
      return state.setIn(['createWard', 'isLoading'], true)
    }

    case WardsTypes.CREATE_WARD_SUCCESS: {
      return state.setIn(['createWard', 'isLoading'], false)
    }

    case WardsTypes.CREATE_WARD_FAILURE: {
      return state.setIn(['createWard', 'isLoading'], false)
    }

    case WardsTypes.DELETE_WARD_REQUEST: {
      return state
    }

    case WardsTypes.DELETE_WARD_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case WardsTypes.DELETE_WARD_FAILURE: {
      return state
    }

    case WardsTypes.FETCH_WARDS_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case WardsTypes.FETCH_WARDS_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case WardsTypes.FETCH_WARDS_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case WardsTypes.FETCH_WARD_REQUEST: {
      return state.setIn(['updateWard', 'isLoading'], true)
    }

    case WardsTypes.FETCH_WARD_SUCCESS: {
      return state
        .setIn(['updateWard', 'isLoading'], false)
        .setIn(['updateWard', 'data'], fromJS(action.payload))
    }

    case WardsTypes.FETCH_WARD_FAILURE: {
      return state.setIn(['updateWard', 'isLoading'], false)
    }

    case WardsTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case WardsTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
